import {apiHelper} from "../redux/apiHelper"
export const getCmsPolicyPage=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/cms-policy-page/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addCmsPolicyPage=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/cms-policy-page/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateCmsPolicyPage=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/cms-policy-page/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getCmsPolicyPageById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/cms-policy-page/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteCmsPolicyPageById=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/cms-policy-page/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}